<template>
    <section class="MetaRankingHeaderInfo" v-if="loading || staticContentText" v-skeleton="{
        loading,
        sizes: {
            Small: { width: '100%', height: '3rem' },
            ExtraLarge: { width: '100%', height: '3rem' },
        }
    }">

        <section :class="[static.StaticContainer, {[static.LineClamp]: !toggledContent}]">
            <div :class="static.StaticContent" v-html="staticContentText"/>
            <ol v-if="urls.length" class="UrlList">
                <li class="UrlListItem" v-for="url in urls" :key="url.getUrl()">
                    <a class="UrlListItemLink" :title="url.getText()" :href="url.getUrl()" target="_blank">{{ url.getText() }}</a>
                </li>
            </ol>
        </section>

        <button
            class="ToggleContentBtn"
            @click="toggleContent"
            :aria-expanded="toggledContent"
            :aria-label="toggledText"
            data-id="toggle-grogu-content"
        >
            {{ toggledText }}
            <i class="lnr-cross Icon" v-if="toggledContent"></i>
        </button>

    </section>
</template>

<script setup lang="ts">
import { useSearchStore } from '@stores/useSearchStore';
import { computed, ref } from 'vue';

const store = useSearchStore();
const staticContentText = computed(()=> store.pageData?.staticContentText);
const toggledContent = ref(false);
const toggledText = computed(() => toggledContent.value ? 'Close' : 'Show more');
const urls = computed(() => store.pageData?.staticContentUrls || []);
const loading = computed(() => store.loading);

const toggleContent = () => {
    toggledContent.value = !toggledContent.value;
};
</script>

<style module="static" lang="scss">
    .StaticContainer {

        display: flex;
        flex-direction: column;

        .StaticContent{
            @include TextStyle(BodyMediumRegular);
            @include MarginAreas(0);

            h2{
                color: $Grey-900;
                @include TextStyle(HeadingExtraSmall);
                @include MarginAreas(0, 0, 1, 0);
            }

            a {
                color: $Blue-700;
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }

            p {
                @include MarginAreas(0, 0, 1, 0);
            }
        }

        &.LineClamp {
            @include LineClamp(1);
        }
    }
</style>

<style scoped lang="scss">
    .MetaRankingHeaderInfo {
        display: flex;
        align-items: flex-start;
        gap: 1rem;
        width: 100%;
        color: $Grey-900;
        border-bottom:  1px solid $Grey-200;
        @include PaddingAreas(0, 0, 1);

        .ToggleContentBtn {
            display: flex;
            background: transparent;
            border: none;
            cursor: pointer;
            gap: 0.25rem;
            color: $Blue-700;
            white-space: nowrap;
            align-items: center;
            @include TextStyle(BodyMediumSemibold);
            @include PaddingAreas(0);

            .CloseIcon {
                font-size: 1rem;
                margin: 0.3125rem;
            }

        }
        .UrlList {
            display: grid;
            row-gap: 0.5rem;
            column-gap: 2rem;

            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
            @include PaddingAreas(0, 1);
            @include Breakpoint(ExtraLarge, Large, Medium) {
                grid-auto-flow: column;
                grid-template-rows: repeat(5, auto);
                grid-auto-columns: 1fr;
            }

            .UrlListItem {
                word-break: break-word;
                overflow-wrap: break-word;
                @include MarginAreas(0);

                .UrlListItemLink {
                    overflow: hidden;
                    color: $Blue-700;
                    text-decoration: none;
                    overflow-wrap: anywhere;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }
        }
}
</style>